import React, { FC } from 'react';
import { Grid } from '@mui/material';
import { Control } from 'react-hook-form';
import { FilterRowType, FormFilterRow } from 'src/components/Form';

interface Props {
    control: Control<any, object>;
}

const filters: FilterRowType<any>[] = [
    {
        title: 'Name',
        placeholder: 'type category name',
        name: 'name'
    }
];

export const FilterForm: FC<Props> = ({ control }) => (
    <form>
        <Grid container sx={{ minWidth: 600, width: '50vw', pl: 1, pr: 1 }}>
            {filters.map(filter => (
                <FormFilterRow
                    key={filter.name}
                    control={control}
                    {...filter}
                />
            ))}
        </Grid>
    </form>
);
